///<reference path="../../../charts/line-chart-builder.ts"/>
///<reference path="../../../charts/chart-director.ts"/>

module Meevo.Plugins.Controls {

    import ChartDirector = Meevo.Components.Charts.ChartDirector;
    import ILineChartDataRow = Meevo.Components.Charts.ILineChartDataRow;
    import LineChartBuilder = Meevo.Components.Charts.LineChartBuilder;
    declare let d3: any;

    const REBUILD_DELAY: number = 500;

    class MeevoLineChartComponent<T> extends BaseChart<T, ILineChartDataRow> {
        static $inject = ['$scope', '$element', '$timeout'];

        public options: Object;

        constructor($scope, $element, $timeout) {
            super($scope, $element, $timeout);
        }

        $onInit() {
            super.$onInit();

            angular.element(window).on('resize', _.debounce(() => {
                this.$scope.$apply(() => {
                    this.buildChart();
                });
            }, REBUILD_DELAY));
        }

        prepareData() {
            super.prepareData();

            this.buildChart();
        }

        buildChart() {
            if (!this.data || this.data instanceof Array && this.data.length === 0) return;

            this.$timeout(() => {
                const chartPlace: HTMLElement = this.$element.find('.line-chart-d3')[0];

                const chartBuilder = new LineChartBuilder(chartPlace, this.data, {...this.options, ...{width: chartPlace.clientWidth}});

                ChartDirector.buildProductivityGoalsChart(chartBuilder);
            }, REBUILD_DELAY);
        }
    }


    angular.module('meevo.components.controls')
        .component('meevoLineChartD3Component', <angular.IComponentOptions>{
            templateUrl: 'app/components/controls/charts/line-chart-d3/line-chart.html',
            controller: MeevoLineChartComponent,
            controllerAs: '$ctrl',
            bindings: {
                title: '@',
                inputData: '<',
                mapFn: '=',
                options: '<'
            }
        });
}
